export const theme = {
  colors: {
    // Brand
    primary:       '#2E53A1',
    primaryHover:  '#24428a',
    primaryLight:  '#eaf0fb',
    primaryBorder: '#b3c6ed',

    // Secondary (accent)
    secondary:       '#EA591F',
    secondaryHover:  '#c44a18',
    secondaryLight:  '#fdf0eb',
    secondaryBorder: '#f5bda4',

    // Semantic
    success:       '#10b981',
    successLight:  '#ecfdf5',
    successBorder: '#6ee7b7',
    warning:       '#f59e0b',
    warningLight:  '#fffbeb',
    warningBorder: '#fde68a',
    danger:        '#ef4444',
    dangerLight:   '#fef2f2',
    dangerBorder:  '#fecaca',
    info:          '#2E53A1',
    infoLight:     '#eaf0fb',
    infoBorder:    '#b3c6ed',

    // Neutrals
    white:   '#ffffff',
    bg:      '#f8fafc',
    bgCard:  '#ffffff',
    bgSecondary: '#f1f5f9',
    border:  '#e2e8f0',
    borderHover: '#cbd5e1',

    // Text
    textPrimary:   '#0f172a',
    textSecondary: '#475569',
    textMuted:     '#64748b',
    textInverse:   '#ffffff',

    // Aliases semânticos
    error: '#ef4444',

    // Gray scale
    gray50:  '#f8fafc',
    gray100: '#f1f5f9',
    gray200: '#e2e8f0',
    gray300: '#cbd5e1',
    gray400: '#94a3b8',
    gray500: '#64748b',
    gray600: '#475569',
    gray700: '#334155',
    gray800: '#1e293b',
    gray900: '#0f172a',

    // Cores por persona de agente (avatares, badges)
    agents: {
      sofia:  '#10b981',
      carlos: '#EA591F',
      ana:    '#2E53A1',
    },

    // Cores por vertical de mercado (marketplace, filtros)
    sectors: {
      saude:      '#2E53A1',
      educacao:   '#EA591F',
      varejo:     '#f59e0b',
      financeiro: '#24428a',
    },

    // Cores de canal
    channels: {
      whatsapp:  '#25d366',
      whatsappHover: '#1ebe5d',
      telegram:  '#2AABEE',
      instagram: '#E1306C',
      email:     '#EA591F',
    },

    // Roxos — usados em ShareCard, PublicLink, Alexa
    purple900: '#4c1d95',
    purple700: '#6d28d9',
    purple600: '#7c3aed',
    purpleLight: '#ede9fe',
    purpleBorder: '#c4b5fd',

    // Chat WhatsApp
    chatBg:           '#efeae2',
    chatBubbleAgent:  '#d9fdd3',
  },

  typography: {
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontMono:   "'JetBrains Mono', 'Fira Code', monospace",

    // Scale
    xs:   '0.75rem',   // 12px
    sm:   '0.875rem',  // 14px
    base: '1rem',      // 16px
    lg:   '1.125rem',  // 18px
    xl:   '1.25rem',   // 20px
    '2xl':'1.5rem',    // 24px
    '3xl':'1.875rem',  // 30px
    '4xl':'2.25rem',   // 36px

    // Weight
    normal:   400,
    medium:   500,
    semibold: 600,
    bold:     700,

    // Line height
    tight:  1.25,
    snug:   1.375,
    normal_lh: 1.5,
    relaxed: 1.625,
  },

  spacing: {
    0:  '0px',
    1:  '0.25rem',  // 4px
    2:  '0.5rem',   // 8px
    3:  '0.75rem',  // 12px
    4:  '1rem',     // 16px
    5:  '1.25rem',  // 20px
    6:  '1.5rem',   // 24px
    8:  '2rem',     // 32px
    10: '2.5rem',   // 40px
    12: '3rem',     // 48px
    16: '4rem',     // 64px
    20: '5rem',     // 80px
  },

  radii: {
    sm:   '0.375rem',  // 6px
    md:   '0.5rem',    // 8px
    lg:   '0.75rem',   // 12px
    xl:   '1rem',      // 16px
    '2xl':'1.5rem',    // 24px
    full: '9999px',
  },

  shadows: {
    sm:  '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md:  '0 4px 6px -1px rgb(0 0 0 / 0.07), 0 2px 4px -2px rgb(0 0 0 / 0.05)',
    lg:  '0 10px 15px -3px rgb(0 0 0 / 0.08), 0 4px 6px -4px rgb(0 0 0 / 0.05)',
    xl:  '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.05)',
    inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
  },

  transitions: {
    fast:   'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base:   'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow:   'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    // Curvas isoladas para uso em transform/opacity individuais
    easing: {
      ease:    'cubic-bezier(0.4, 0, 0.2, 1)',
      easeIn:  'cubic-bezier(0.4, 0, 1, 1)',
      easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    },
  },

  breakpoints: {
    sm:  '640px',
    md:  '768px',
    lg:  '1024px',
    xl:  '1280px',
    '2xl': '1536px',
  },

  zIndex: {
    dropdown: 100,
    sticky:   200,
    modal:    300,
    toast:    400,
  },
};

// Helpers para media queries
export const mq = {
  sm:  `@media (min-width: ${theme.breakpoints.sm})`,
  md:  `@media (min-width: ${theme.breakpoints.md})`,
  lg:  `@media (min-width: ${theme.breakpoints.lg})`,
  xl:  `@media (min-width: ${theme.breakpoints.xl})`,
  mobile: `@media (max-width: 639px)`,
};

// Helper de foco — aplica em styled components que precisam de focus-visible customizado
// Uso: ${focusRing} dentro de um styled component
export const focusRing = `
  &:focus-visible {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 2px;
    border-radius: ${theme.radii.sm};
  }
`;
